import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const PRODUCT_REQUEST = 'sherrinford/product/list/PRODUCT_REQUEST'
export const PRODUCT_SUCCESS = 'sherrinford/product/list/PRODUCT_SUCCESS'
export const PRODUCT_ERROR = 'sherrinford/product/list/PRODUCT_ERROR'

export const PRODUCT_LIST_REQUEST = 'sherrinford/product/list/PRODUCT_LIST_REQUEST'
export const PRODUCT_LIST_SUCCESS = 'sherrinford/product/list/PRODUCT_LIST_SUCCESS'
export const PRODUCT_LIST_ERROR = 'sherrinford/product/list/PRODUCT_LIST_ERROR'

export const NEW_PRODUCT_REQUEST = 'sherrinford/product/list/NEW_PRODUCT_REQUEST'
export const NEW_PRODUCT_SUCCESS = 'sherrinford/product/list/NEW_PRODUCT_SUCCESS'
export const NEW_PRODUCT_ERROR = 'sherrinford/product/list/NEW_PRODUCT_ERROR'

export const SEARCH_PROFILE_REQUEST = 'sherrinford/profile/list/SEARCH_PROFILE_REQUEST'
export const SEARCH_PROFILE_SUCCESS = 'sherrinford/profile/list/SEARCH_PROFILE_SUCCESS'
export const SEARCH_PROFILE_ERROR = 'sherrinford/profile/list/SEARCH_PROFILE_ERROR'

export const PROFILE_SEARCH = 'sherrinford/product/list/PROFILE_SEARCH'
export const PROFILE_SEARCH_IDS = 'sherrinford/product/list/PROFILE_SEARCH_IDS'

export const SEARCH_CLEAN = 'sherrinford/product/list/PROFILE_SEARCH_CLEAN'

export const COUNTRY_STATE = 'sherrinford/product/list/COUNTRY_STATE'
export const SERVICE_STATE = 'sherrinford/product/list/SERVICE_STATE'
export const BRAND_NEW_PROFILES = 'sherrinford/product/listBRAND_NEW_PROFILES'

export const IS_LOADING = 'sherrinford/product/list/IS_LOADING'
export const DATA = 'sherrinford/product/list/DATA'

export const SET_SORT_FIELD = 'sherrinford/product/list/SET_SORT_FIELD'
export const SET_SORT_ORDER = 'sherrinford/product/list/SET_SORT_ORDER'

export const SET_FILTER_VALUE = 'sherrinford/product/list/SET_FILTER_VALUE'
export const SET_SORT_VALUE = 'sherrinford/product/list/SET_SORT_VALUE'

export const CLEAR_FILTER_SORT = 'sherrinford/product/list/CLEAR_FILTER_SORT'

export const SET_FILTER_STATUS = 'sherrinford/product/list/SET_FILTER_STATUS'

export const RESET_FILTER = 'sherrinford/product/list/RESET_FILTER'

export const SET_ROW_CLICKABLE = 'sherrinford/product/list/SET_ROW_CLICKABLE'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [{
      productTags: [],
      profile: {
        profileId: '',
      },
      isEligible: false,
      city: {
        name: '',
        slug: '',
        id: '',
      },
      country: {
        name: '',
        official_name: '',
        code: '',
        currencyCode: '',
        is_active: '',
        slug: '',
        id: '',
      },
      createdBy: {},
      updatedBy: {},
      format: {
        name: '',
      },
      service: {
        name: '',
      },
      productType: {
        name: '',
      },
      productLanguage: {},
      isPublished: false,
      logo: '',
      name: '',
      tags: '',
      viewers: 0,
      description: '',
      targetAgeFrom: 0,
      targetAgeTo: 0,
      status: 0,
      slug: '',
      createdAt: '',
      updatedAt: '',
      id: '',
      priceFixed: 0,
      priceFrom: 0,
      priceTo: 0,
      portfolios: {
        count: 0,
        currentPage: 1,
        totalPages: 1,
        rows: [{
          status: 0,
        }],
      },
      legacy: false,
      statusLabel: '',
    }],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  isLoading: false,
  isError: false,
  errorMessage: '',

  searchProfileField: '',
  searchProfileIds: [],

  brandNewProfiles: [],

  status: {
    onReview: {
      label: 'On Review',
      value: 0,
    },
    approved: {
      label: 'Approved',
      value: 1,
    },
    rejected: {
      label: 'Rejected',
      value: 2,
    },
  },

  productTypeSlug: {
    create: 'create',
    sponsor: 'sponsor',
  },

  filter: {
    searchKey: '',
    createdStartDate: null,
    createdEndDate: null,
    updatedStartDate: null,
    updatedEndDate: null,
    isCreatedEndDateActive: false,
    isUpdatedEndDateActive: false,
    country: '',
    type: '',
    service: '',
    format: '',
    publishStatus: '',
    status: '',
    productType: '',
  },

  sort: {
    active: '',
    createdAt: 'ASC',
    updatedAt: 'ASC',
  },

  sortField: 'updatedAt',
  sortOrder: 'DESC',
  filterStatus: -1,
  countryState: '',
  serviceState: '',
  isRowClickable: true,
}

export default createReducer(initialState, {
  [PRODUCT_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PRODUCT_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PRODUCT_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [PRODUCT_LIST_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PRODUCT_LIST_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PRODUCT_LIST_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [NEW_PRODUCT_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [NEW_PRODUCT_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [NEW_PRODUCT_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [SEARCH_PROFILE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [SEARCH_PROFILE_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [SEARCH_PROFILE_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [PROFILE_SEARCH]: (state, data) => ({
    ...state,
    searchProfileField: data,
  }),

  [PROFILE_SEARCH_IDS]: (state, data) => ({
    ...state,
    searchProfileIds: data,
  }),

  [SEARCH_CLEAN]: state => ({
    ...state,
    searchProfileField: initialState.searchProfileField,
    searchProfileIds: initialState.searchProfileIds,
    countryState: initialState.countryState,
    serviceState: initialState.serviceState,
    filterStatus: initialState.filterStatus,
    sortField: initialState.sortField,
    sortOrder: initialState.sortOrder,
  }),

  [COUNTRY_STATE]: (state, data) => ({
    ...state,
    countryState: data,
  }),

  [SERVICE_STATE]: (state, data) => ({
    ...state,
    serviceState: data,
  }),

  [BRAND_NEW_PROFILES]: (state, data) => ({
    ...state,
    brandNewProfiles: data,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
  [SET_SORT_FIELD]: (state, data) => ({
    ...state,
    sortField: data,
  }),
  [SET_SORT_ORDER]: (state, data) => ({
    ...state,
    sortOrder: data,
  }),

  [SET_FILTER_VALUE]: (state, data) => ({
    ...state,
    filter: {
      ...state.filter,
      ...data,
    },
  }),

  [SET_SORT_VALUE]: (state, data) => ({
    ...state,
    sort: {
      ...state.sort,
      ...data,
    },
  }),

  [SET_FILTER_STATUS]: (state, data) => ({
    ...state,
    filterStatus: data,
  }),

  [CLEAR_FILTER_SORT]: state => ({
    ...state,
    filter: initialState.filter,
    sort: initialState.sort,
  }),

  [RESET_FILTER]: state => ({
    ...state,
    filter: initialState.filter,
  }),

  [SET_ROW_CLICKABLE]: (state, data) => ({
    ...state,
    isRowClickable: data,
  }),
})

export const getProducts = (payloads, cb = () => { }) => {
  const token = JSON.parse(isAuthorized())
  localStorage.setItem('filterPendingProduct', JSON.stringify(payloads))
  return {
    type: [
      PRODUCT_REQUEST,
      PRODUCT_SUCCESS,
      PRODUCT_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/product',
      authorization: `${token}`,
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export const getProductList = (payloads) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      PRODUCT_LIST_REQUEST,
      PRODUCT_LIST_SUCCESS,
      PRODUCT_LIST_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/product',
      authorization: `${token}`,
      payloads,
    },
  }
}

export const getNewProducts = (payloads, cb = () => { }) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      NEW_PRODUCT_REQUEST,
      NEW_PRODUCT_SUCCESS,
      NEW_PRODUCT_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/product/brand_new',
      authorization: `${token}`,
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export const setData = (data, cb = () => { }) => ({
  type: [DATA],
  payload: data,
  nextAction: res => cb(res),
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const profileInput = data => ({
  type: [PROFILE_SEARCH],
  payload: data,
})

export const profileIdsSearch = data => ({
  type: [PROFILE_SEARCH_IDS],
  payload: data,
})

export const searchClean = () => ({
  type: [SEARCH_CLEAN],
})

export const searchForProfiles = (data, cb = () => { }) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      SEARCH_PROFILE_REQUEST,
      SEARCH_PROFILE_SUCCESS,
      SEARCH_PROFILE_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/profile',
      authorization: `${token}`,
      payloads: data,
    },
    nextAction: res => cb(res),
  }
}

export const setCountryState = data => ({
  type: [COUNTRY_STATE],
  payload: data,
})

export const setServiceState = data => ({
  type: [SERVICE_STATE],
  payload: data,
})

export const setBrandNewProfiles = data => ({
  type: [BRAND_NEW_PROFILES],
  payload: data,
})

export const setSortField = data => ({
  type: [SET_SORT_FIELD],
  payload: data,
})

export const setSortOrder = data => ({
  type: [SET_SORT_ORDER],
  payload: data,
})

export const setFilterValue = data => ({
  type: [SET_FILTER_VALUE],
  payload: data,
})

export const setSortValue = data => ({
  type: [SET_SORT_VALUE],
  payload: data,
})

export const setFilterStatus = data => ({
  type: [SET_FILTER_STATUS],
  payload: data,
})

export const clearFilterSort = data => ({
  type: [CLEAR_FILTER_SORT],
  payload: data,
})

export const resetFilter = () => ({
  type: [RESET_FILTER],
})

export const setRowClickAble = data => ({
  type: [SET_ROW_CLICKABLE],
  payload: data,
})
